var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { EventEmitter } from '@angular/core';
import { ControlContainer } from '@angular/forms';
import { AbstractDwFormItemComponent } from '../../form-field/abstract-dw-form-item-component';
import { TranslateParser } from '@ngx-translate/core';
import { toBoolean } from '../../../utils/convert';
var DwFormSelectComponent = /** @class */ (function (_super) {
    __extends(DwFormSelectComponent, _super);
    function DwFormSelectComponent(_fg, _ts) {
        var _this = _super.call(this, _fg, _ts) || this;
        _this._fg = _fg;
        _this._ts = _ts;
        _this._showSearch = false;
        _this.compareWith = function (o1, o2) { return o1 === o2; };
        _this.dwAllowClear = false;
        _this.dwOpen = false;
        _this.dwOpenChange = new EventEmitter();
        _this.dwAutoFocus = false;
        _this.dwDisabled = false;
        _this.dwDropdownMatchSelectWidth = true;
        _this.dwServerSearch = false;
        _this.dwFilterOption = defaultFilterOption;
        _this.dwMaxMultipleCount = Infinity;
        _this.dwMode = 'default';
        _this.dwSize = 'default';
        _this.dwScrollToBottom = new EventEmitter();
        _this.dwOnSearch = new EventEmitter();
        _this.dwIsLoading = false;
        return _this;
    }
    Object.defineProperty(DwFormSelectComponent.prototype, "dwShowSearch", {
        get: function () {
            return this._showSearch;
        },
        set: function (value) {
            this._showSearch = toBoolean(value);
        },
        enumerable: true,
        configurable: true
    });
    DwFormSelectComponent.prototype.afterContentInit = function () { };
    DwFormSelectComponent.prototype.change = function (event) {
        this.onChange(event);
    };
    DwFormSelectComponent.prototype.onInit = function () { };
    return DwFormSelectComponent;
}(AbstractDwFormItemComponent));
export { DwFormSelectComponent };
export function defaultFilterOption(input, option) {
    if (option && option.dwLabel) {
        return option.dwLabel.toLowerCase().indexOf(input.toLowerCase()) > -1;
    }
    else {
        return false;
    }
}
